module.exports = __webpack_public_path__ + "static/cainbycs-8fdcc940d311551aad7b19eda15fd923.png";